import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { axiosAuth } from "../../helpers"

const useOtpShow = () => {
    const navigate = useNavigate()
    const baseUrl = process.env.REACT_APP_BASEURL

    const [otpUrl, setOtpUrl] = useState("")
    const [otp, setOtp] = useState("")
    const [status, setStatus] = useState("idle") // idle | loading | succeeded | failed | otpEnabled
    const [error, setError] = useState(null)
    const [isActivated, setIsActivated] = useState(false)

    const handleStart = async () => {
        setStatus("loading")
        setError(null)

        try {
            const otp_token = localStorage.getItem("otp_token")

            const res = await axiosAuth.post("/v1/otp/setup", {
                token: otp_token,
            })

            setOtpUrl(res.data.data.otp_url)
            localStorage.setItem("otp_url", res.data.data.otp_url)
            localStorage.setItem("otp_enabled", res.data.data.otp_enabled)

            setIsActivated(true)
            setStatus("idle")
        } catch (err) {
            console.log(err)
            if (err.response?.data?.message == 'OTP has enabled') {
                setError("OTP sudah diaktifkan")
                setStatus("otpEnabled")
            } else {
                setError("Gagal memuat QR Code")
                setStatus("failed")
            }
        }
    }

    const handleVerify = async (e) => {
        e.preventDefault()
        setStatus("loading")
        setError(null)

        try {
            const otp_token = localStorage.getItem("otp_token")

            const res = await axiosAuth.post("/otp/set-enable", {
                token: otp_token,
                otp,
            })

            localStorage.setItem("token", res.data.data.token)
            navigate("/")
        } catch (err) {
            setError("OTP tidak valid")
            setStatus("failed")
        }
    }

    return {
        baseUrl,
        otpUrl,
        otp,
        status,
        error,
        isActivated,
        setOtp,
        handleStart,
        handleVerify,
    }
}

export default useOtpShow
